if (!customElements.get('clothing-mega-menu')) {
  customElements.define('clothing-mega-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.clothing-mega-menu__panel');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.closeTimer = null;

      this.addEventListener('mouseenter', () => this.open());
      this.addEventListener('mouseleave', () => this.scheduleClose());
      this.addEventListener('focusin', () => this.open());
      this.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!this.contains(document.activeElement) && !this.panel.contains(document.activeElement)) this.close();
      }));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.summary.addEventListener('click', () => requestAnimationFrame(() => this.syncExpanded()));
      this.panel.addEventListener('mouseenter', () => window.clearTimeout(this.closeTimer));
      this.panel.addEventListener('mouseleave', () => this.scheduleClose());
      this.panel.addEventListener('focusin', () => window.clearTimeout(this.closeTimer));
      this.panel.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!this.contains(document.activeElement) && !this.panel.contains(document.activeElement)) this.close();
      }));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target) && !this.panel.contains(event.target)) this.close();
      });
      window.addEventListener('resize', () => this.syncPosition(), { passive: true });
      window.addEventListener('scroll', () => this.details.open && this.syncPosition(), { passive: true });
      this.desktop.addEventListener('change', (event) => {
        if (!event.matches) {
          this.close();
          this.details.appendChild(this.panel);
        }
      });
    }

    open() {
      if (!this.desktop.matches) return;
      window.clearTimeout(this.closeTimer);
      if (this.panel.parentElement !== document.body) document.body.appendChild(this.panel);
      document.querySelectorAll('.header__inline-menu details[open]').forEach((details) => {
        if (details !== this.details) details.removeAttribute('open');
      });
      document.querySelectorAll('.home-image-mega-menu__panel[data-open="true"], .shop-all-mega-menu__panel[data-open="true"]').forEach((panel) => panel.removeAttribute('data-open'));
      this.syncPosition();
      this.details.open = true;
      this.syncExpanded();
    }

    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.close(), 150);
    }

    close() {
      window.clearTimeout(this.closeTimer);
      this.details.removeAttribute('open');
      this.syncExpanded();
    }

    syncPosition() {
      if (!this.desktop.matches) return;
      const header = this.closest('.header-wrapper') || this.closest('.section-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : this.summary.getBoundingClientRect().bottom;
      this.panel.style.setProperty('--clothing-mega-top', `${Math.round(headerBottom)}px`);
    }

    syncExpanded() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
      if (this.details.open && this.desktop.matches) {
        this.syncPosition();
        this.panel.dataset.open = 'true';
      } else {
        this.panel.removeAttribute('data-open');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.summary.focus();
      } else if (event.key === 'ArrowDown' && event.target === this.summary) {
        event.preventDefault();
        this.open();
        this.panel.querySelector('a')?.focus();
      }
    }
  });
}
